import React, { useState, useRef, useEffect } from "react";
import { useUserNotifications } from "../../context/UserNotificationsContext";
import { NotificationsDropdown } from "./NotificationsDropdown";
import { Bell, KeyIcon } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";
import { UserRoles } from "../../types/user.types";

export const TopBar: React.FC = () => {
  const { notifications } = useUserNotifications();
  const [isNotificationsOpen, setIsNotificationsOpen] = useState(false);
  const dropdownRef = useRef<HTMLDivElement>(null);
  const navigate = useNavigate();
  const { user } = useAuth();

  const unreadCount =
    notifications?.filter((n) => n.status === "unread").length || 0;

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        dropdownRef.current &&
        !dropdownRef.current.contains(event.target as Node)
      ) {
        setIsNotificationsOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <div className="h-16 bg-white border-b border-gray-200 flex items-center justify-between px-4">
      <div className="flex-1"></div>

      <div className="flex items-center space-x-4">
        <div className="relative" ref={dropdownRef}>
          {(user?.roleId === UserRoles.CLIENT_ADMIN ||
            user?.roleId === UserRoles.SYSTEM_ADMIN) && (
            <button
              onClick={() => navigate("/dashboard/me/reset-password")}
              className="p-2 rounded-full hover:bg-gray-100"
            >
              <KeyIcon className="h-6 w-6 text-gray-600" />{" "}
            </button>
          )}

          <button
            onClick={(e) => {
              e.stopPropagation();
              setIsNotificationsOpen(!isNotificationsOpen);
            }}
            className="p-2 rounded-full hover:bg-gray-100 relative"
          >
            <Bell className="h-6 w-6 text-gray-600" />
            {unreadCount > 0 && (
              <span className="absolute -top-1 -right-1 bg-red-500 text-white text-xs rounded-full h-5 w-5 flex items-center justify-center">
                {unreadCount}
              </span>
            )}
          </button>

          {isNotificationsOpen && (
            <div className="absolute right-0 mt-2 z-50">
              <NotificationsDropdown
                onClose={() => setIsNotificationsOpen(false)}
              />
            </div>
          )}
        </div>
      </div>
    </div>
  );
};
